import React, { useContext, useEffect, useMemo, useState } from "react";
import { PosContext } from "../../../shared/PosContext";
import { getOrderShortName } from "../../../utils/floorUtils";
import { useStyles } from "./styles";

import { Add } from "@mui/icons-material";
import { AppBar } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

function TakeawayOrderTabs({}) {
    const navigate = useNavigate();
    const classes = useStyles();

    const { takeawayTable, customers, refetchCustomers } =
        useContext(PosContext);

    const { orderName } = useParams();

    const [orders, setOrders] = useState([]);
    const [value, setValue] = useState();

    useEffect(() => {
        if (orderName) {
            setValue(orderName);
        } else {
            setValue("new_order");
        }
    }, [orderName]);

    useEffect(() => {
        if (customers && takeawayTable) {
            const tmpOrders = [];
            const findCustomer = (customer) => {
                const cust = customers.find((i) => i.name === customer);
                return cust;
            };

            Object.values(takeawayTable.orders).forEach((order) => {
                tmpOrders.push({
                    order: order,
                    customer: findCustomer(order.customer),
                });
            });
            setOrders(tmpOrders);
        }
    }, [takeawayTable, customers]);

    const filteredOrders = useMemo(() => {
        return orders;
    }, [orders]);

    const handleChange = (event, newValue) => {
        if (newValue == "new_order") {
            navigate(`/pos/${takeawayTable.tableDescription}`);
        } else {
            navigate(`/pos/${takeawayTable.tableDescription}/${newValue}`);
        }
    };

    return (
        <div className={classes.TakeawayTabs}>
            <AppBar position="static">
                {" "}
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    {filteredOrders.map((order) => (
                        <Tab
                            key={`order-tab-${order.order.name}`}
                            label={getOrderShortName(order.order.name)}
                            value={order.order.name}
                            {...a11yProps(order.order.name)}
                        />
                    ))}
                    <Tab
                        icon={<Add />}
                        value={"new_order"}
                        {...a11yProps("new_order")}
                    />
                </Tabs>
            </AppBar>
        </div>
    );
}

export default TakeawayOrderTabs;
